module.exports = __webpack_public_path__ + "img/unelmakone-karta-fi.89b93574.jpg";